// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__8YWLD","navIcon":"Nav_navIcon__KiahK","active":"Nav_active__pvaeQ"};